module.exports = __webpack_public_path__ + "static/media/34.491fd903.jpg";